export default __webpack_public_path__ + "static/media/flow5.05b7afaf.svg";